import type { JSX } from "react";
import styled from "styled-components";
import { currentColors } from "../../shared/colors";
import t from "../../shared/translations";

interface IProps {
    pathId: string;
}

const ButtonAnchor = styled.a`
    display: inline-block;
    padding: 16px 32px 16px 32px;
    margin: 0;
    background-color: ${currentColors.button};
    color: white;
    line-height: normal;

    &:hover, &:focus, &:active {
        color: white;
    }
`;

function DownloadAnswers({ pathId }: IProps): JSX.Element {
    return (
        <ButtonAnchor target="_blank" href={`/pdf/download/my-answers/${pathId}/my-answers.pdf`}>
            {t("player.my-answers.button-download-answers")}
        </ButtonAnchor>
    );
}

export default DownloadAnswers;
